import { create } from 'zustand'

interface DevModeStore {
  isDevMode: boolean
  checkDevMode: () => boolean
  enableDevMode: () => void
  disableDevMode: () => void
}

export const useDevModeStore = create<DevModeStore>((set, get) => ({
  isDevMode: false,
  
  checkDevMode: () => {
    // 開発環境（localhost:3000）かチェック
    const isLocalhost = window.location.hostname === 'localhost' && window.location.port === '3000'
    
    // URLパラメータをチェック
    const params = new URLSearchParams(window.location.search)
    const devParam = params.get('dev')
    
    // localhost:3000 または dev=2025 の場合、開発者モード有効
    const isDevMode = isLocalhost || devParam === '2025'
    
    set({ isDevMode })
    
    // 開発者モード有効時はconsoleにメッセージ
    if (isDevMode) {
      if (isLocalhost) {
        console.log('🚀 開発者モード有効（開発環境）')
      } else {
        console.log('🚀 開発者モード有効（URLパラメータ）')
      }
    }
    
    return isDevMode
  },
  
  enableDevMode: () => {
    set({ isDevMode: true })
    console.log('🚀 開発者モード有効')
  },
  
  disableDevMode: () => {
    set({ isDevMode: false })
    console.log('👋 開発者モード無効')
  }
}))